import React from "react";

const SubCategorySkeleton = () => {
  return (
    <div className="bg-white py-10 animate-pulse">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-10 gap-2 items-center">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="flex flex-col items-center">
            <div className="w-24 h-24 rounded-full bg-gray-200"></div>
            <div className="h-4 w-20 bg-gray-200 mt-3 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubCategorySkeleton;
